import { Message } from "primereact/message";
import styled from "styled-components";

/**
 * An orange notice of the benefits panel: a white box with an orange border, orange text.
 * The three-class selector outranks the theme's `.p-inline-message.p-inline-message-warn`.
 */
export const WarnMessage = styled(Message)`
  &.p-inline-message.p-inline-message-warn {
    background: var(--brand-white);
    border: 1px solid currentColor;
    border-radius: 1rem;
  }
`;
